import { render, staticRenderFns } from "./MonthlyOverdueTableData.vue?vue&type=template&id=7968e98d&scoped=true"
import script from "./MonthlyOverdueTableData.vue?vue&type=script&lang=js"
export * from "./MonthlyOverdueTableData.vue?vue&type=script&lang=js"
import style0 from "./MonthlyOverdueTableData.vue?vue&type=style&index=0&id=7968e98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968e98d",
  null
  
)

export default component.exports